module.exports = __webpack_public_path__ + "img/icon_chip_03.83ecabf6.png";